/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.array.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import Popup from "vux/src/components/popup/index.vue";
import ViewBox from "vux/src/components/view-box/index.vue";
import PopupPicker from "vux/src/components/popup-picker/index.vue";
import Group from "vux/src/components/group/index.vue";
import Cell from "vux/src/components/cell/index.vue";
import CellBox from "vux/src/components/cell-box/index.vue";
import XInput from "vux/src/components/x-input/index.vue";
import XButton from "vux/src/components/x-button/index.vue";
import { getReceiptDetail, getReceiptExtField, getServiceAmount, getSaveReceipt, getVerifyCode } from '@/api';
import CustomFormList from '@/components/CustomFormList';
import ImgUpload from '@/components/ImgUpload';
import ServiceAmountTable from '../ServiceAmountTable/index';
export default {
  components: {
    Popup: Popup,
    ViewBox: ViewBox,
    PopupPicker: PopupPicker,
    Group: Group,
    XButton: XButton,
    Cell: Cell,
    CellBox: CellBox,
    XInput: XInput,
    CustomFormList: CustomFormList,
    ServiceAmountTable: ServiceAmountTable,
    ImgUpload: ImgUpload
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: String
    },
    orderInfo: {
      type: Object
    },
    isServiceAmount: {
      type: Boolean,
      default: false
    },
    iseditCount: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loading: false,
      showContent1: true,
      showContent2: true,
      showContent3: true,
      currValue: this.value,
      ReceiptExtField: [],
      receiptTmplMap: {},
      totalTime: '',
      service: {},
      sparePartList: [],
      moneyItemList: [],
      editShow: false,
      writeShow: false,
      wait: 60,
      count: 0,
      clear: '',
      customFields: [],
      extServiceItems: [],
      from: {
        pics: [],
        code: '',
        signImg: ''
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('globalStore', ['user'])), {}, {
    isShowCode: function isShowCode() {
      return [2, 3, 4].includes(this.service.receipt_type);
    },
    isShowSign: function isShowSign() {
      return [1, 3, 4].includes(this.service.receipt_type);
    }
  }),
  watch: {
    value: function value(val) {
      this.currValue = val;

      if (val) {
        this.loadEditAmount();
      }
    },
    currValue: function currValue(val) {
      var _this = this;

      if (val) {
        this.$setLeft({
          control: true,
          onSuccess: function onSuccess() {
            _this.currValue = false;
          }
        });
      } else {
        this.$setLeft({
          control: false
        });
      }

      this.$emit('input', val);
    },
    writeShow: function writeShow(val) {
      var _this2 = this;

      if (val) {
        this.$setLeft({
          control: true,
          onSuccess: function onSuccess() {
            _this2.writeShow = false;
          }
        });
      } else {
        this.$setLeft({
          control: true,
          onSuccess: function onSuccess() {
            _this2.currValue = false;
          }
        });
      }
    },
    editShow: function editShow(val) {
      var _this3 = this;

      if (val) {
        this.$setLeft({
          control: true,
          onSuccess: function onSuccess() {
            _this3.editShow = false;
          }
        });
      } else {
        this.$setLeft({
          control: true,
          onSuccess: function onSuccess() {
            _this3.currValue = false;
          }
        });
      }
    }
  },
  methods: {
    // 初始化
    loadData: function loadData() {
      var _this4 = this;

      getReceiptDetail({
        oid: this.orderId
      }).then(function (res) {
        if (res.success) {
          _this4.receiptTmplMap = res.data.receiptTmplMap;
          _this4.totalTime = res.data.totalTime;
        }
      });
      getReceiptExtField({
        oid: this.orderId
      }).then(function (res) {
        if (res.success) {
          _this4.ReceiptExtField = res.data;
        }
      });
      this.loadEditAmount();
    },
    // 编辑款项用
    loadEditAmount: function loadEditAmount() {
      var _this5 = this;

      getServiceAmount({
        oid: this.orderId
      }).then(function (res) {
        if (res.success) {
          _this5.service = res.data.service;
          _this5.sparePartList = res.data.sparePartList;
          _this5.moneyItemList = res.data.moneyItemList;
          _this5.extServiceItems = res.data.extServiceItems || [];
        } else {
          _this5.$vux.toast.text(res.message);
        }
      });
    },
    // 编辑款项回显加载
    reload: function reload() {
      this.loadEditAmount();
    },
    // 提交回执
    submit: function submit(type) {
      var _this6 = this;

      // 0-无 1-手写签名 2 客户确认码 3 手写签名和客户确认码 4 手写签名或客户确认码
      var receiptType = this.service.receipt_type || 0; // 1 : save 2: customer

      var map = {
        0: function _() {
          return true;
        },
        1: function _(type) {
          if (type === 1) {
            if (!_this6.from.signImg) {
              _this6.$vux.toast.text('手写签名不能为空');

              return false;
            }
          }

          return true;
        },
        2: function _(type) {
          if (!_this6.from.code) {
            _this6.$vux.toast.text('确认码不能为空');

            return false;
          }

          return true;
        },
        3: function _(type) {
          // if (type === 2) {
          //   this.$vux.toast.text('确认码不能为空')
          //   return false
          // }
          if (!_this6.from.code || !_this6.from.signImg) {
            _this6.$vux.toast.text('手写签名和确认码不能为空');

            return false;
          }

          return true;
        },
        4: function _(type) {
          if (type === 1 && !_this6.from.code && !_this6.from.signImg) {
            _this6.$vux.toast.text('手写签名或确认码不能为空');

            return false;
          }

          return true;
        }
      };
      this.$refs.customFormLists.formValidate().then(function (valid) {
        if (valid && map[receiptType].call(_this6, type)) {
          var data = {
            oid: _this6.orderId,
            pics: _this6.from.pics,
            signImg: _this6.from.signImg,
            type: type,
            isReceiptValid: _this6.service.is_receipt_valid ? _this6.service.is_receipt_valid : 0,
            listField: _this6.customFields,
            code: _this6.from.code
          };
          _this6.loading = true;
          getSaveReceipt(data).then(function (res) {
            _this6.loading = false;

            if (res.success) {
              if (type === 1) {
                _this6.$vux.toast.text('回执单保存成功');
              } else if (type === 2) {
                _this6.$vux.toast.text('回执单发送成功');
              }

              _this6.currValue = false;

              _this6.$emit('on-success');
            } else {
              _this6.$vux.toast.text(res.message);
            }
          });
        }
      });
    },
    // 发送短信
    verifyCode: function verifyCode() {
      var _this7 = this;

      if (this.wait === 60) {
        var data = {
          oid: this.orderId
        };
        getVerifyCode(data).then(function (res) {
          if (res.success) {
            _this7.wait = 59;

            _this7.waitAMoment();

            _this7.$vux.toast.text('发送成功');
          } else {
            _this7.$vux.toast.text(res.message);
          }
        });
      }
    },
    // 延时60s
    waitAMoment: function waitAMoment() {
      var _this8 = this;

      this.clear = setTimeout(function () {
        _this8.wait--;

        _this8.waitAMoment();

        if (_this8.wait < 0) {
          clearTimeout(_this8.clear);
          _this8.wait = 60;
        }
      }, 1000);
    }
  },
  created: function created() {
    this.loadData();
  }
};